import { Injectable } from '@angular/core';
import { IUsersListPayload, IUsersListResponse, IUserUpdatePayload } from '../models/users.models';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ApiService } from '../../../../core/services/api.service';

@Injectable({
	providedIn: 'root',
})
export class UsersService extends ApiService {
	public list(body: IUsersListPayload): Observable<IUsersListResponse> {
		return this.http.post<IUsersListResponse>(environment.apiUrl + `/users`, body, {
			headers: this.getHeaders(),
		});
	}

	public update(id: string, body: IUserUpdatePayload): Observable<any> {
		return this.http.patch<any>(environment.apiUrl + `/user/${id}`, body, {
			headers: this.getHeaders(),
		});
	}

	public delete(id: string): Observable<any> {
		return this.http.delete<any>(environment.apiUrl + `/user/${id}`, {
			headers: this.getHeaders(),
		});
	}
}
